import React, {Fragment, useEffect, useState} from "react";
import ModalOverlay from "../../../components/modal-overlay/modal-overlay";
import TextHeadline from "canvas-core-react/lib/TextHeadline";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import Margin from "canvas-core-react/lib/Margin";
import PinTextField from "canvas-core-react/lib/PinTextField";
import IconCompleteIllustrative from "canvas-core-react/lib/IconCompleteIllustrative";
import TextBody from "canvas-core-react/lib/TextBody";
import AlertBanner from "canvas-core-react/lib/AlertBanner";
import {useAppContext} from "../../../context/AppContext";
import "./modal-phone.scss";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import Link from "canvas-core-react/lib/Link";
import {WealthService} from "../../../services";
import RetryErrorComponent from "../../../components/error-components/retry-error";

const ModalPhone = ({onClose}) => {
    const {
        changeItem: setContext,
        state: context,
        displayError,
    } = useAppContext();

    const [buttonSend, setButtonSend] = useState(true);
    const [pin, setPin] = useState();

    const wealthService = new WealthService();

    const onChangePin = (value, index) => {
        if (value.length > 3) {
            setButtonSend(false);
        } else {
            setButtonSend(true);
        }

        setPin(value);
    };

    useEffect(() => {
        fetchSms()
        // eslint-disable-next-line
    }, [])

    const sendPin = async () => {
        setContext({
            loading: true,
        });

        await wealthService
            .validateNotification({
                key: context.subjectId,
                transaction_id: context.smsToken,
                code: pin,
            })
            .then((res) => {
                setContext({
                    isValidPhone: res.valid,
                    loading: false,
                });
                onClose();
            })
            .catch((error) => {
                displayError(error);
            })
            .finally(() => {
                setContext({
                    loading: false,
                });
            });
    };

    const fetchSms = async () => {
        setContext({loading: true});
        await wealthService
            .sendNotification(context.subjectId)
            .then((res) => {
                setContext({
                    smsToken: res.transaction_id,
                    loading: false,
                });
            })
            .catch((error) => {
                displayError(error, fetchSms, <RetryErrorComponent retryCallBack={fetchSms}/>);
            })
            .finally(() => {
                setContext({loading: false});
            });
    };

    return (
        <Fragment>
            <ModalOverlay className={"modal-content-phone"}>
                <div id="title-container">
                    <Margin
                        xs={[0, 0, 24, 0]}
                        sm={[0, 0, 24, 0]}
                        md={[0, 0, 24, 0]}
                        lg={[0, 0, 24, 0]}
                    >
                        <TextHeadline component="div" className="modal__text" size="small">
                            Ingresa tu número telefónico para recibir el código de
                            verificación
                        </TextHeadline>
                    </Margin>
                </div>
                <div className="textfield-container">
                    <Row>
                        <Column>
                            <Margin
                                xs={[0, 0, 24, 0]}
                                sm={[0, 0, 24, 0]}
                                md={[0, 0, 24, 0]}
                                lg={[0, 0, 24, 0]}
                            >
                                <PinTextField
                                    label="Ingresa el código verificador"
                                    id="code"
                                    length={4}
                                    labelShowButton="Show Pin"
                                    labelHideButton="Hide Pin"
                                    onChange={onChangePin}
                                />
                            </Margin>
                        </Column>
                    </Row>
                    {context.isValidPhone && (
                        <Row>
                            <Column>
                                <Margin
                                    xs={[0, 0, 24, 0]}
                                    sm={[0, 0, 24, 0]}
                                    md={[0, 0, 24, 0]}
                                    lg={[0, 0, 24, 0]}
                                >
                                    <div className="media">
                                        <div className="media-object">
                                            <IconCompleteIllustrative id="icon-complete"/>
                                        </div>
                                        <div className="media-content">
                                            <TextBody component="small">Tu PIN es válido</TextBody>
                                        </div>
                                    </div>
                                </Margin>
                            </Column>
                        </Row>
                    )}
                    <Row>
                        <Column>
                            <Margin
                                xs={[0, 0, 24, 0]}
                                sm={[0, 0, 24, 0]}
                                md={[0, 0, 24, 0]}
                                lg={[0, 0, 24, 0]}
                            >
                                <TextBody component="p" className={"align-items--center"}>
                                    <Link weight="regular" onClick={fetchSms} href="#" id="link-fetch-sms">
                                        El código no ha llegado a mi teléfono. Volver a enviar.
                                    </Link>
                                </TextBody>
                            </Margin>
                        </Column>
                    </Row>
                    <Row>
                        <Column>
                            <Margin
                                xs={[0, 0, 24, 0]}
                                sm={[0, 0, 24, 0]}
                                md={[0, 0, 24, 0]}
                                lg={[0, 0, 24, 0]}
                            >
                                <AlertBanner type="info">
                                    Enviamos un mensaje de texto al número +56* **** **** con el{" "}
                                    {""}
                                    <TextSubtitle component="span">
                                        código verificador
                                    </TextSubtitle>
                                    , el cual tiene un tiempo de caducidad de solo 5 minutos.
                                </AlertBanner>
                            </Margin>
                        </Column>
                    </Row>
                    <Row>
                        <Column>
                            <Margin
                                xs={[0, 0, 24, 0]}
                                sm={[0, 0, 24, 0]}
                                md={[0, 0, 24, 0]}
                                lg={[0, 0, 24, 0]}
                            >
                                <PrimaryButton
                                    id="button-submit-phone"
                                    disabled={buttonSend}
                                    onClick={sendPin}
                                >
                                    Enviar
                                </PrimaryButton>
                            </Margin>
                        </Column>
                    </Row>
                    <Row>
                        <Column>
                            <SecondaryButton id="button-close-phone" onClick={onClose}>
                                Volver
                            </SecondaryButton>
                        </Column>
                    </Row>
                </div>
            </ModalOverlay>
        </Fragment>
    );
};

export default ModalPhone;
